import { createFileRoute } from "@tanstack/react-router";
import { trpc } from "@/hooks/trpc";
import { ProtocolEditorLayout } from "@/features/harvest-protocol/protocol-editor-layout";

export const Route = createFileRoute(
  "/harvests/protocols/$protocol_id/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { protocol_id } = Route.useParams();
  const { data: protocol } =
    trpc.harvest.protocols.getWithFullDetails.useQuery(protocol_id);

  if (!protocol) return null;

  return <ProtocolEditorLayout protocolId={protocol_id} />;
}
